<template>
	<v-footer
		:padless="true"
		class="footer pt-4 pt-sm-0">
		<span
			class="subhead-2 footer__link footer__link--project-name"
			:class="$vuetify.theme.dark ? 'whitebase--text' : 'graybase--text'">&copy; {{ project.name }}. {{ $t('footer.all_rights_reserved') }}.</span>
		<a
			v-for="footerItem in linksCombined"
			:key="footerItem.name"
			:href="footerItem.link"
			target="_blank"
			class="subhead-2 footer__link"
			:class="$vuetify.theme.dark ? 'whitebase--text' : 'graybase--text'">
			{{ $t(footerItem.name) }}
		</a>
	</v-footer>
</template>

<script>
import { getEnv } from "../env"

export default {
	data (){
		return{
			appCountry: getEnv('VUE_APP_FRONTEND_COUNTRY'),
			project: { name : getEnv('VUE_APP_FRONTEND_PROJECT_NAME'), link : "#" },
			footerItems: [
				{ name: "footer.about", link: getEnv('VUE_APP_FRONTEND_FOOTER_ABOUT') },
				//{ name: "footer.contacts", link: getEnv('VUE_APP_FRONTEND_FOOTER_ABOUT') },
				//{ name: "footer.schoolList", link: "#", },
			],
			termLinks: {
				ru: [
					{ name: "footer.terms", link : 'http://ekool.company/ru/%d1%83%d1%81%d0%bb%d0%be%d0%b2%d0%b8%d1%8f-2' },
				],
				et: [
					{ name: "footer.terms", link : 'http://ekool.company/et/kasutustingimused' },
				],
				en: [
					{ name: "footer.terms", link : 'http://ekool.company/en/terms-2' },
				],
				de: [
					{ name: "footer.terms", link : 'http://ekool.company/en/terms-2' },
				],
				fr: [
					{ name: "footer.terms", link : 'http://ekool.company/en/terms-2' },
				],
				ja: [
					{ name: "footer.terms", link : 'http://ekool.company/en/terms-2' },
				],
				lv: [

				],
			},
			contactFormUrl: getEnv('VUE_APP_FRONTEND_CONTACT_FORM_URL'),
		}
	},
	computed:{
		computedLinks () {
			return [
				{ name: "footer.contacts", link: this.getContactFormUrl(this.$i18n.locale) },
				{ name: "footer.terms", link : `https://ekool.eu/terms/terms_${this.$i18n.locale}.html` },
			]
		},
		linksCombined () {
			if(getEnv('VUE_APP_FRONTEND_COUNTRY') == 'EU' && getEnv('VUE_APP_FRONTEND_PROJECT_NAME') == 'eKool'){
				return [...this.footerItems, ...this.computedLinks]
			}
			else{
				return this.footerItems
			}
		},
	},
	mounted (){
		if(this.project.name == 'Mykoob'){
			this.project.link = "https://login.mykoob.lv/login/";
			this.footerItems = [
				{ name: "terms.terms_of_service", link: getEnv('VUE_APP_FRONTEND_APP_URL') + '/#/lv/terms/service' },
				{ name: "terms.privacy_policy", link: getEnv('VUE_APP_FRONTEND_APP_URL') + '/#/lv/terms/privacy-policy' },
				{ name: "footer.support", link: "https://mykoob.freshdesk.com/support/home" },
				{ name: "footer.schoolList", link: "https://www.mykoob.lv/?index/skolu_saraksts" },
				{ name: "footer.contacts", link: "https://mykoob.freshdesk.com/support/tickets/new" },
			]
		}
	},
	methods:{
		getContactFormUrl (locale) {
			switch(locale){
			case 'en':
				return this.contactFormUrl + '/en_US'
			case 'ru':
				return this.contactFormUrl + '/ru_RU'
			default:
				return this.contactFormUrl
			}
		},
	},
}
</script>
